module.exports = __webpack_public_path__ + "img/img_power.6296bb37.png";